import styled from 'styled-components';
import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import type { FilterDataOption } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterMultiSelect } from '@/app/common/filters/types/multiSelect/FilterMultiSelect.tsx';
import { NO_STAR_RATING_VALUE } from '@/app/common/filters/core/starsValues.ts';
import { Separator } from '@/app/common/filters/surfaces/styled.ts';

// An <li>, because FilterMultiSelect renders its options inside <Column as="ul">.
const NoRatingSeparator = styled.li`
  list-style: none;
  padding: ${({ theme }) => theme.kallisto.space.space100} 0;
`;

const separatorBeforeNoRating = (previous: FilterDataOption, option: FilterDataOption) =>
  option.value === NO_STAR_RATING_VALUE && previous.value !== NO_STAR_RATING_VALUE ? (
    <NoRatingSeparator key="stars-no-rating-separator" aria-hidden="true">
      <Separator />
    </NoRatingSeparator>
  ) : undefined;

// columns={1}: the separator is a row, so this list is single-column by definition.
export const StarsFilterMultiSelect = (props: FilterComponentProps) => (
  <FilterMultiSelect {...props} columns={1} renderBetween={separatorBeforeNoRating} showCounter={false} />
);
